export const WA_LINK =
  "https://wa.me/919846159693?text=Hello%20PK%20Hygiene!%20I%27d%20like%20to%20book%20a%20cleaning%20service.";
export const PHONE_DISPLAY = "+91 98461 59693";
export const PHONE_TEL = "tel:+919846159693";
export const INSTA_LINK = "https://instagram.com/pkhygiene";

export const scrollToId = (e, id) => {
  e.preventDefault();
  if (window.__lenis) {
    window.__lenis.scrollTo(id, { offset: -70 });
  } else {
    document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
  }
};
